import { fetchGet, fetchPost, fetchPut, fetchDelete, fetchDownload, fetchDownloadData } from './http';

//login
export const apiLogin = data => fetchPost('/cmsauth/login', data);
export const apiRefresh = () => fetchGet('/cmsauth/refresh');
export const apiResetPassword = data => fetchPut('/reset-pwd/current', data);
export const apiPubKey = () => fetchGet('/cmsauth/pubKey');
export const apiUserLogout = () => fetchGet('/logout-cms');
export const apiAzureAdLogin = (data) => fetchPost('/cmsauth/aad/login', data);
export const currentUserInfo = () => fetchGet('/current-user/info');


//app user

export const appUserList = data => fetchGet('/appuser/', data);
export const appUserDetail = id => fetchGet('/appuser/' + id);
export const appUserSuspend = (id, data) => fetchPut('appuser/suspend/' + id, data);
export const appUserUnlock = (id) => fetchPut('appuser/unlock/' + id);
export const appUserDelete = (id) => fetchDelete('appuser/' + id);
export const appUserEmail = (id, data) => fetchPut('appuser/email/' + id, data);
export const appUserResetPwd = (id, data) => fetchPut('appuser/reset/pwd/' + id, data);
export const appUserEdit = (id, data) => fetchPut('appuser/' + id, data);
export const appAddUser = (data) => fetchPost('/appuser/add/dummy', data);
export const runOnDemand = (data) => fetchPost('/appuser/fetch/ondemend', data);
export const appUserExport = (data) => fetchDownloadData('/appuser/downloadCsv', data);
export const Export = (data, sort) => fetchDownloadData('/appuser/downloadCsv' + sort, data);
export const appInvestment = (id, type) => fetchGet('/appuser/' + id + '/investments/' + type)
export const documents = (id, data) => fetchGet('/appuser/' + id + '/documents/', data)
export const documentsProjects = (id) => fetchGet('/appuser/' + id + '/documents/projects')
export const documentsType = (id) => fetchGet('/appuser/' + id + '/documents/types')
export const documentsDetail = (id, data) => fetchGet('/appuser/' + id + '/documents/' + data, data)
export const appProducts = (data) => fetchGet('/appProducts/', data)
export const optionDocType = () => fetchGet('/option/docType')

export const getPassport = (link) => fetchGet(link)



//biz user
export const bizUserList = data => fetchGet('/businessPartner/', data);
export const bizUserDetail = (sfUserType, id) => fetchGet('/businessPartner/' + sfUserType + '/' + id);
export const bizUserClientList = (sfUserType, id, data) => fetchGet('/businessPartner/' + sfUserType + '/' + id + '/clients/', data);
export const bizUserClientListMasterPlan = (sfUserType, id) => fetchGet('/businessPartner/' + sfUserType + '/' + id + '/clients/masterPlan');
export const bizUserClientListProject = (sfUserType, id) => fetchGet('/businessPartner/' + sfUserType + '/' + id + '/clients/project');
export const bizUserClientListRegion = (sfUserType, id) => fetchGet('/businessPartner/' + sfUserType + '/' + id + '/clients/region');
export const bizUserExport = (data, sort) => fetchDownloadData('/businessPartner/downloadCsv' + sort, data);
export const bizUserClientExport = (sfUserType, id, data) => fetchDownloadData('/businessPartner/' + sfUserType + '/' + id + '/downloadClients', data);
export const runFetchBizUserSchedule = () => fetchPost('/businessPartner/fetch');
export const employeesFindAll = () => fetchGet('/employees/findAll');

//cms user
export const cmsUserList = data => fetchGet('/cmsuser/findAll', data);
export const cmsIRList = data => fetchGet('/employees/getIRUsers', data);
export const cmsUserDetails = (id) => fetchGet('/cmsuser/details/' + id);
export const cmsAddUser = (data) => fetchPost('/cmsuser/add', data);
export const cmsPermissions = data => fetchGet('/cmsuser/permissions', data);
export const employeesCmsuser = data => fetchGet('/employees/cmsuser/pending-assign', data);

//ir user
export const irInvite = (data) => fetchPost('/employees/inviteIRUser', data);
export const irDeactivate = (data) => fetchPost('/employees/deactivateIRUser', data);
export const irResetPassword = (data) => fetchPost('/employees/resetIRUserPassword', data);


export const cmsUserEdit = (id, data) => fetchPut('/cmsuser/edit/' + id, data);
export const cmsUserDelete = (id) => fetchDelete('/cmsuser/delete/' + id);
export const cmsUserResetPwd = (id, data) => fetchPut('/cmsuser/reset/pwd/' + id, data);

//customer service hotline
export const serviceHotlineList = data => fetchGet('/contactUs/clientServices/', data);
export const serviceHotlineDelete = id => fetchDelete('/contactUs/clientServices/' + id);
export const serviceHotlineAdd = data => fetchPost('/contactUs/clientServices', data);
export const serviceHotlineDetail = id => fetchGet('/contactUs/clientServices/' + id);
export const serviceHotlineUpdate = (id, data) => fetchPut('/contactUs/clientServices/' + id, data);

//option api
export const getCountry = () => fetchGet('/country/');
export const getSalesOffice = () => fetchGet('/salesregion/officelist');
export const getSalesRegion = (office) => fetchGet('/salesregion/list/' + office);
export const getAllSalesRegion = () => fetchGet('/salesregion/list');
export const getUserStatus = () => fetchGet('/option/userstatus');
export const getUserType = () => fetchGet('/option/usertype');

export const getProjectLocation = () => fetchGet('/option/projectLocation');
export const getProjectStatus = () => fetchGet('/option/projectStatus');
export const getProjectType = () => fetchGet('/option/projectType');
export const getProjectUnit = () => fetchGet('/option/projectUnit');
export const getSfUserTypes = () => fetchGet('/option/sfUserType');

//office location
export const officesList = data => fetchGet('/contactUs/offices/', data);
export const officesDelete = id => fetchDelete('/contactUs/offices/' + id);
export const officesAdd = data => fetchPost('/contactUs/offices', data);
export const officesDetail = id => fetchGet('/contactUs/offices/' + id);
export const officesUpdate = (id, data) => fetchPut('/contactUs/offices/' + id, data);

//product
export const projectList = data => fetchGet('/projects/', data);
export const projectAdd = data => fetchPost('/projects', data);
export const projectDelete = id => fetchDelete('/projects/' + id);
export const projectDetail = id => fetchGet('/projects/' + id);
export const projectUpdate = (id, data) => fetchPut('/projects/' + id, data);
export const projectclone = (id, data) => fetchPost('/projects/' + id + '/clone', data);


//notification
export const notificationList = data => fetchGet('/notification/list', data);
export const notificationRevoke = id => fetchDelete('/notification/revoke/' + id);
export const notificationAdd = data => fetchPost('/notification/add', data);
export const notificationDetail = id => fetchGet('/notification/details/' + id);
export const notificationUpdate = (id, data) => fetchPut('/notification/edit/' + id, data);
export const notificationClientList = (data) => fetchGet('/notification/client/list', data);
export const notificationClientListDelete = (id) => fetchDelete('/notification/client/clear/' + id);
export const notificationClone = (id, data) => fetchPost('/notification/clone/' + id, data);


//campagin
export const campaginList = data => fetchGet('/campaignPopup/list', data);
export const campaignDetail = id => fetchGet('/campaignPopup/details/' + id);
export const campaignUpdate = (id, data) => fetchPut('/campaignPopup/' + id, data);

//generic contents
export const contentList = data => fetchGet('/genericContents/', data);
export const genericContentAdd = data => fetchPost('/genericContents/', data);
export const genericContentUpdate = (id, data) => fetchPut('/genericContents/' + id, data);
export const contentDetail = id => fetchGet('/genericContents/' + id);
export const contentDelete = id => fetchDelete('/genericContents/' + id);

//other
export const apiGetMediaUrl = data => fetchPost('/aws/getMediaUrl', data);

//audit log analytics
export const auditLogDashboard = data => fetchGet('/auditLogAnalytics/dashboard', data);
export const auditLogConsultants = data => fetchGet('/auditLogAnalytics/consultants', data);





// WEBPACK FOOTER //
// ./src/request/api.js